import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrganizationReportingService } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { MyOrganizationFacade } from '@piqet-angular/data';
import { GridCellDropdownComponent } from '../grid-cell-dropdown/grid-cell-dropdown.component';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { UploadSKUDataGridService } from 'libs/features/src/lib/layout/organization-report/upload-sku-data/upload-sku-data-grid.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Subscription, catchError, finalize, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { GuideTourEnum } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-add-sku-data',
  templateUrl: './add-sku-data.component.html',
  styleUrls: ['./add-sku-data.component.scss'],
})
export class AddSkuDataComponent {
  @Output() saveSKUData = new EventEmitter<any>();

  disableSubmit = false;
  scenarioList: any;
  productList: any;
  skuData: any;
  modalLabel: any;
  skuAddEditForm!: FormGroup;
  scenarioId: any;
  departmentString: any;
  catString: any;
  subCatString: any;
  patchedProduct: any;
  patchedScenario: any;
  submitted: boolean = false;
  disbaledDropDown!: boolean;
  productId: any;
  skuCategoryId: any;
  skuSubCategoryId: any;
  patchedDept: any;
  patchedCategory: any;
  patchedSubCategory: any;
  allSkuDept: any;
  categoryList: any;
  yearList: any;
  processColumnDef: any;
  disableSubscription!: Subscription;
  skuError!: Subscription;
  isRowEditable = false;
  allSkuCat: any;
  allSkuSubCat: any;
  @ViewChild('myButton') buttonRef!: ElementRef;
  @ViewChild('myPopover') popover!: NgbPopover;
  @ViewChild('myPopoverTwo') popoverTwo!: NgbPopover;
  allDepartments: any;
  allCategoryData: any;
  allSubCategoryData: any;
  categoryListByDeptId: any;
  skuDeptId: any;
  subCategoryList: any;
  skuCatgId: any;
  skuSubCatgId: any;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    dropdownRendered: GridCellDropdownComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private organizationReportService: OrganizationReportingService,
    public myOrganizationFacade: MyOrganizationFacade,
    private uploadSKUDataGridService: UploadSKUDataGridService,
    private sharedService: SharedService,
    private toaster: ToastrService,
    private cookieService: CookieService
  ) {
    this.skuData = this.modal?.modalService?.config?.initialState?.['skuData'];
    this.productId = this.skuData?.productId;
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.disbaledDropDown = this.modalLabel == 'Review internal data' ? true : false;
  }

  ngAfterViewInit() {
    if (!this.skuData.isTourCompleted) this.triggerPopup();
  }

  ngOnInit(): void {
    this.processColumnDef = this.uploadSKUDataGridService.addSKUYearGrid();
    const getFullYear = new Date().getFullYear();
    const yearList = this.skuData?.yearItems.filter((x: any) => x.description <= getFullYear);
    this.processColumnDef[1].cellEditorParams['yearList'] = yearList;
    this.skuAddEditForm = this.formBuilder.group({
      product: [null],
      scenario: [null, Validators.required],
      productClass: [this.skuData?.subCategory],
      productFamily: [this.skuData?.category, Validators.required],
      productDepartment: [null],
      UUIDCode: [null],
    });
    this.getProduct();
    this.setFormData();

    this.skuError = this.myOrganizationFacade.skuYearError$.subscribe((error: any) => {
      this.checkValidation(error);
    });

    this.disableSubscription = this.sharedService.disableAddRowBtnTrigger$.subscribe(
      (error: any) => {
        this.checkEditingStatus(error);
      }
    );
  }

  setFormData() {
    this.skuAddEditForm.patchValue({
      product: this.patchedProduct,
      productDepartment: this.patchedDept,
      productFamily: this.patchedCategory,
      productClass: this.patchedSubCategory,
      scenario: this.skuData.scenarioId,
      UUIDCode: this.skuData.uuid,
    });
    if (!!this.patchedProduct) this.getScenarioListBasedOnProductId();
    this.scenarioList = this.skuData?.scenarioList;
    this.productList = this.skuData?.productList;
    this.allDepartments = this.skuData?.productDepartmentItems;
    this.allCategoryData = this.skuData?.productFamilyItems;
    this.categoryListByDeptId = this.allCategoryData.filter((x: any) => x.parentRefID == 0);
    this.allSubCategoryData = this.skuData?.productClassItems;
    this.subCategoryList = this.allSubCategoryData.filter((x: any) => x.parentRefID == 0);
    this.skuDeptId = this.skuData?.skuDepartmentId > 0 ? this.skuData?.skuDepartmentId : null;
    this.skuCatgId = this.skuData?.skuCategoryId > 0 ? this.skuData?.skuCategoryId : null;
    this.skuSubCatgId = this.skuData?.skuSubCategoryId > 0 ? this.skuData?.skuSubCategoryId : null;
    this.getDept();
  }

  checkValidation(yearSKUError: any): void {
    this.disableSubmit = !!yearSKUError ? true : false;
  }

  checkEditingStatus(err: any) {
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }

  async getProduct() {
    await this.skuData?.productList.map((item: any) => {
      if (item.idStr == this.skuData?.productId) {
        return (this.patchedProduct = item);
      }
    });
  }

  async getDept() {
    await this.allDepartments?.map((item: any) => {
      if (item.idLong == this.skuData?.skuDepartmentId) {
        this.patchedDept = item;
        this.skuAddEditForm.patchValue({ productDepartment: this.patchedDept });
        return;
      }
    });
    this.getSKUCategory();
  }

  async getCategory() {
    await this.categoryListByDeptId?.map((item: any) => {
      if (item.idLong == this.skuData?.skuCategoryId) {
        this.patchedCategory = item;
        this.skuAddEditForm.patchValue({ productFamily: this.patchedCategory });
        return;
      }
    });
    this.getSKUSubCategory();
  }

  async getSubCategory() {
    await this.subCategoryList?.map((item: any) => {
      if (item.idLong == this.skuData?.skuSubCategoryId) {
        this.patchedSubCategory = item;
        this.skuAddEditForm.patchValue({ productClass: this.patchedSubCategory });
        return;
      }
    });
  }

  async getSKUCategory() {
    this.categoryListByDeptId = this.allCategoryData.filter(
      (x: any) => x.parentRefID == (this.skuData.skuDepartmentId ?? 0)
    );
    this.getCategory();
  }

  async getSKUSubCategory() {
    this.subCategoryList = this.allSubCategoryData.filter(
      (x: any) => x.parentRefID == (this.skuData.skuCategoryId ?? 0)
    );
    this.getSubCategory();
  }
  async getSKUCategoryByCategoryId(id: any) {
    this.subCategoryList = (
      await this.organizationReportService.getSkuSubCategoryCategoryId(id)
    ).data;
  }

  clearDept(type?: any) {
    if (type == 'prod') {
      this.scenarioList = this.skuData?.scenarioList;
      this.productList = this.skuData?.productList;
      this.productId = null;
    }
    this.skuAddEditForm.controls['productDepartment'].reset();
    this.skuAddEditForm.controls['productFamily'].reset();
    this.skuAddEditForm.controls['productClass'].reset();
    this.setDefaultData('resetToDefault');
  }

  setDefaultData(type: string) {
    switch (type) {
      case 'resetToDefault':
        this.skuCategoryId = null;
        this.skuDeptId = null;
        this.skuSubCategoryId = null;
        this.categoryList = this.allSkuCat;
        this.subCategoryList = this.allSkuSubCat;
        break;
      case 'clearCatg':
        this.subCategoryList = this.skuDeptId ? [] : this.allSkuSubCat;
        break;
      default:
        break;
    }
  }

  clearCatg() {
    this.skuAddEditForm.controls['productClass'].reset();
    this.skuCategoryId = null;
    this.skuSubCategoryId = null;
    this.setDefaultData('clearCatg');
  }

  commonInputSearch(term: string, item: any) {
    return item?.name.toLowerCase().includes(term.toLowerCase());
  }

  async selectedScenario(event: any, drpType?: any) {
    if (event?.idStr || event?.id || event.idLong) {
      if (drpType == 'prod') {
        this.productId = Number(event.idStr);
        this.skuAddEditForm.controls['scenario'].reset();
        this.skuAddEditForm.controls['productClass'].reset();
        this.skuAddEditForm.controls['productFamily'].reset();
        this.skuAddEditForm.controls['productDepartment'].reset();
        this.setDefaultData('resetToDefault');
        this.getScenarioListBasedOnProductId();
      } else {
        this.scenarioId = Number(event.idLong) ? Number(event.idLong) : event.id;
        const response = await this.organizationReportService.getScenarioSKUData(
          this.scenarioId,
          this.productId
        );
        const scenarioData = response.data;
        if (scenarioData.id != 0) {
          this.setSKUValues(scenarioData);
        } else if (scenarioData.id == 0 && drpType == 'scenario') {
          this.skuAddEditForm.patchValue({
            productClass: null,
            productFamily: null,
            productDepartment: null,
          });
          this.setDefaultData('resetToDefault');
        }
      }
    } else if (!event && drpType == 'scenario') {
      this.scenarioId = null;
    } else if (!event && drpType == 'prod') {
      this.productId = null;
    }
  }

  onClose() {
    this.myOrganizationFacade.clearStorageProcess();
    this.modal.close();
  }

  async setSKUValues(data: any) {
    let skuDept;
    this.skuData?.departmentList.map((item: any) => {
      if (item.idLong == data?.skuDepartmentId) {
        return (skuDept = item);
      }
    });

    await this.getSKUCategoryByCategoryId(data.skuCategoryId);
    this.subCategoryList = (
      await this.organizationReportService.getSkuSubCategoryCategoryId(data.skuCategoryId)
    ).data;

    let skuCatg;
    this.categoryList?.map((item: any) => {
      if (item.idLong == data?.skuCategoryId) {
        return (skuCatg = item);
      }
    });

    let skuSubCatg;
    this.subCategoryList?.map((item: any) => {
      if (item.idLong == data?.skuSubCategoryId) {
        return (skuSubCatg = item);
      }
    });

    this.skuAddEditForm.patchValue({
      productClass: skuSubCatg,
      productFamily: skuCatg,
      productDepartment: skuDept,
    });
    this.skuDeptId = this.skuAddEditForm.controls['productDepartment'].value?.idLong;
    this.skuCategoryId = this.skuAddEditForm.controls['productFamily'].value?.idLong;
    this.skuSubCategoryId = this.skuAddEditForm.controls['productClass'].value?.idLong;
  }

  async changeDept(event: any) {
    if (event.idLong) {
      this.skuDeptId = event.idLong;
      this.categoryListByDeptId = this.allCategoryData.filter(
        (x: any) => x.parentRefID == event.idLong
      );
      this.subCategoryList = [];
      this.skuAddEditForm.controls['productFamily'].reset();
      this.skuAddEditForm.controls['productClass'].reset();
    }
  }

  async changeCatg(event: any) {
    if (event.idLong) {
      this.skuCatgId = event.idLong;
      this.subCategoryList = this.allSubCategoryData.filter(
        (x: any) => x.parentRefID == event.idLong
      );
      this.skuAddEditForm.controls['productClass'].reset();
    }
  }

  changeSubCatg(event: any) {
    if (!event.idLong) return;
    this.skuSubCatgId = event.idLong;
  }

  onSave(yearProcessList: any) {
    this.submitted = true;
    if (this.skuAddEditForm.valid) {
      let deptId = this.skuDeptId ?? this.skuData?.skuDepartmentId;
      let categoryId = this.skuCatgId ?? this.skuData?.skuCategoryId;
      let subCategoryId = this.skuSubCatgId ?? this.skuData?.skuSubCategoryId;
      const payload = {
        id: this.skuData?.id || 0,
        scenarioId: this.scenarioId || this.skuData?.scenarioId,
        productId: this.productId,
        department: this.departmentString || this.skuData?.department,
        category: this.catString || this.skuData?.category,
        subCategory: this.subCatString || this.skuData?.subCategory,
        organizationId: Number(this.cookieService.get('organizationId')),
        SKUDepartmentId: deptId == 0 ? null : deptId,
        SKUCategoryId: categoryId == 0 ? null : categoryId,
        SKUSubCategoryId: subCategoryId == 0 ? null : subCategoryId,
        skuDataDetail: yearProcessList,
        uuid: this.skuAddEditForm.get('UUIDCode')?.value,
      };
      this.saveSKUData.emit(payload);
      this.myOrganizationFacade.clearStorageProcess();
    }
  }

  getScenarioListBasedOnProductId() {
    this.organizationReportService
      .getScenarioBasedOnProdId(Number(this.skuAddEditForm.controls['product']?.value?.idStr))
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        this.scenarioList = res.data;
      });
  }

  triggerPopup() {
    const buttonElement = this.buttonRef.nativeElement as HTMLButtonElement;
    buttonElement.click();
    setTimeout(() => {
      this.popover.open();
    }, 0);
  }

  closePopup(step?: any) {
    if (step == 'one') {
      this.popover.close();
      this.popoverTwo.open();
    } else {
      this.popover.close();
      this.popoverTwo.close();
      this.sharedService.updateGuideTourStatus(GuideTourEnum.InternalDataTour, true).subscribe();
    }
  }

  goBack() {
    this.popover.open();
    this.popoverTwo.close();
  }

  closeAllSteps(stepNum: any) {
    this.popover.close();
    this.popoverTwo.close();
    this.sharedService
      .updateGuideTourStatus(GuideTourEnum.InternalDataTour, false, stepNum == 'one' ? 1 : 2)
      .subscribe();
  }

  ngOnDestroy() {
    this.disableSubscription.unsubscribe();
    this.skuError.unsubscribe();
  }
}
